module.exports = __webpack_public_path__ + "img/RMVB_video_icon@2x.e0372a2c.png";